'use client'
import { Viewport } from 'next'
//import useClient from 'next';
import { Inter } from 'next/font/google'
import './globals.css'
import { NextUIProvider } from "@nextui-org/system"
import RiskifiedBeacon from '@/components/riskified'
const inter = Inter({ subsets: ['latin'] })
import ReduxProvider from "@/redux/provider";
import { AuthProvider } from './AuthProvider';
import Image from 'next/image';
import { X } from 'lucide-react';
//import { feathersClient } from '@/components/connection/page'
//import Head from 'next/head';


import { GoogleAnalytics } from '@next/third-parties/google';
import PWAStatusChecker from './PWAStatusChecker';
import OneSignalComponent from './OneSignalComponent'
import MailchimpPopup from './MailchimpPopup';
// import CustomPWAInstall from './CustomPwaInstallModal';

// import PWAInstall1 from './PWAInstall1';

import GTM from './GTM'
import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { isMobile, isTablet } from "react-device-detect";

// import PwaInstall from './PwaInstall'
// import PwaInstall from './PwaInstall';

// export const metadata: Metadata = {
//   manifest:"/manifest.json",
//   title: 'Karma Tickets - Your Trusted Source for Event & Sports Ticket Booking in Canada',
//   description: 'Find tickets for concerts, sports, and events in Canada. Fast, secure booking with exclusive deals at Karma Tickets. Get yours now!',
//   icons:{
//     icon: '/Logo.png',
//   }
// }




export const viewport: Viewport = {
  themeColor: "#397bea",
  width: 'device-width',
  initialScale: 1,
  maximumScale: 1,
  userScalable: false,
};

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {

  const pathname = usePathname();
 
  useEffect(() => {
    // Listen for PWA install event
    const handleAppInstalled = () => {
      localStorage.setItem("pwa-installed", "true");
    };
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  useEffect(() => {

    const isPwaInstalled = localStorage.getItem("pwa-installed");

    if (isPwaInstalled === null) {
      localStorage.setItem("pwa-installed", "false");
    }

    if (isPwaInstalled === "false" && (isMobile || isTablet) && pathname === "/") {
      const timer = setTimeout(() => {
        const el = document.getElementById('pwa-install-element');
        console.log("mobile and tablet", isMobile, isTablet, pathname);

        if (el && typeof (el as any).showDialog === "function") {
          if (isMobile || isTablet){
            console.log("showing dialog");
            (el as any).showDialog();
          } else {
            console.log("not mobile or tablet");
          }
        }
      }, 500);
      return () => clearTimeout(timer);

    } else {
      const el = document.getElementById('pwa-install-element');
      if (el) {
        el.classList.add('hidden'); 
        console.log("hiding dialog");
      }
    }
    
  }, [pathname]);
  
  return (
    <AuthProvider>
      <html lang="en">
        <head>


          <script type="module" src="/pwa-install-unminified.js"></script>

        </head>

        <body className={inter.className}>
          <noscript>
            <iframe
              src={`https://www.googletagmanager.com/ns.html?id=GTM-P99KX6PD`}
              height="0"
              width="0"
              style={{ display: 'none', visibility: 'hidden' }}
            ></iframe>
          </noscript>
          <NextUIProvider>
            <RiskifiedBeacon />
            <GoogleAnalytics gaId='G-0VJR84XEZF' />
            <ReduxProvider>
              <GTM />
              <PWAStatusChecker >
                {/* <script type="module" src="/pwa-install-unminified.js"></script> */}
                <pwa-install
                  id="pwa-install-element"
                  manifest-url="manifest.json"
                  install-description="INSTALL OUR APP! Tap on ‘Add to Home Screen’ below and follow the instructions."
                  name="KARMA APP"
                  description="SPECIALIZING IN GAME DAY DEALS">
                </pwa-install>

                <OneSignalComponent />
                <MailchimpPopup />


                {children}
              </PWAStatusChecker >


            </ReduxProvider>
          </NextUIProvider>



        </body>
      </html>
    </AuthProvider>
  )
}
